/**
 * Popup Auto-Trigger Management
 * Handles popup automatic triggering based on time delay, scroll depth, exit intent, etc.
 */
(function () {
  /**
   * Simple pre-check to avoid setting triggers that are completely impossible to display
   * Only checks local storage records, does not call API
   * @param {String} popupId Popup ID
   * @param {Object} settings Popup settings
   * @return {Boolean} Whether it is possible to display
   */
  const _simplePreCheck = (popupId, settings) => {
    if (!popupId || !settings) return true;

    const timeRangeType = settings.frequency_type ?? '';

    if (timeRangeType === "once") {
      try {
        // Check if the popup has been closed
        const key = "_erj_popup_closed_" + popupId;
        const recordStr = localStorage.getItem(key);
        if (recordStr) {
          const record = JSON.parse(recordStr);
          // If there is a lastClosedTime record, it means it has been displayed
          if (record && record.lastClosedTime) {
            return false;
          }
        }
      } catch (e) {}
    }

    return true;
  };

  /**
   * Set up popup trigger
   * @param {Object} config Popup configuration
   */
  const _setupTrigger = (config) => {
    if (!config || !config.settings) return;

    const { id, settings } = config;

    const { trigger_type, trigger_delay_seconds } = settings;

    //console.log("newsletter countdown");
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get("open_newsletter_popup")) {
        window._erj_.PopupQueue.requestShow(id);
        trigger_delay_seconds = "0";
      }
    } catch (e) {
      console.error(e)
    }

    // Set up trigger
    switch (trigger_type) {
      case "delay":
        const path = window.location.pathname;
        const isLangRoot = /^\/[a-z]{2}$/.test(path.toLowerCase());
        const shouldAutoTrigger = path === "/" || isLangRoot || path.includes("/collections/") || path.includes("/products/");
        if (!shouldAutoTrigger) {
          break;
        }

        // Delay trigger
        const delaySeconds = parseInt(trigger_delay_seconds, 10) || 5;
        
        let hasStartedTimer = false;        
        const scrollHandler = () => {
          console.log("scroll handler");
          if (!hasStartedTimer) {
            hasStartedTimer = true;
            setTimeout(() => {
              window._erj_.PopupQueue.requestShow(id);
            }, delaySeconds * 1000);
            
            window.removeEventListener('scroll', scrollHandler);
          }
        };
        
        window.addEventListener('scroll', scrollHandler);
        break;
    }
  };

  const PopupTriggers = {
    /**
     * Initialize auto-triggers
     * @param {Array} popupConfigs Array of popup configurations
     */
    init(popupConfigs) {
      if (!Array.isArray(popupConfigs)) {
        return;
      }

      popupConfigs.forEach((config) => {
        if (!config || !config.settings) return;

        const { id, settings } = config;

        // Use simple pre-check instead of complete determinePopupDisplay
        // The decision point has been moved to the requestShow method in `popup-queue.js`
        if (_simplePreCheck(id, settings)) {
          _setupTrigger(config);
        }
      });
    },
  };

  // Export to global object
  window._erj_ = window._erj_ || {};
  window._erj_.PopupTriggers = PopupTriggers;
})();
